import { getDateInfo } from "./dateHelper";

let dropdownValue = "";

export const setDropdownValue = (value) => {
  dropdownValue = value;
};

export const getDropdownValue = () => {
  return dropdownValue;
};

export const handleChange = (e, { userDetails, history, setSelectedValue, GA_EVENTS, GaEventHelper }) => {
  GaEventHelper.gaSelectDateEvent({
    userDetails: userDetails,
    screen_name: history?.location?.pathname?.replace("/", ''),
    event: GA_EVENTS.select_date_ucube,
    selectedValue: e.label
  });
  setSelectedValue(e.value);
  localStorage.setItem("selectedDropdownLabel", e.label);
  console.log("check", e.value);
};

export const getLastRefreshedDate = (selectedCountryCode) => {
  const { todaysDateMY, lastRefreshed, todaysDate } = getDateInfo();
  
    return selectedCountryCode === "my" ? todaysDateMY : todaysDate;
  }
